module.exports = __webpack_public_path__ + "img/cisco.9f36ebd8.svg";